import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { OfferAggregateTotalsFragment } from "@/components/offers/collection/OfferAggregateTotals.fragment";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
import { useSubscription } from "../../use-subscription";
const subscription = graphql(`
    subscription useCollectionOfferTotalsSubscription(
      $collectionSlug: String!
    ) {
      collectionOfferAggregatesTotal(collectionSlug: $collectionSlug) {
        totalOffers
        totalValue {
          ...TokenPrice
          token {
            unit
          }
        }
        maxValueInTick {
          token {
            unit
          }
        }
        ...OfferAggregateTotals
      }
    }
  `, [TokenPriceFragment, OfferAggregateTotalsFragment]);
export function useCollectionOfferTotalsSubscription(t0) {
  const $ = _c(4);
  const {
    variables,
    setCollectionOfferTotal
  } = t0;
  let t1;
  if ($[0] !== variables) {
    t1 = {
      query: subscription,
      variables
    };
    $[0] = variables;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setCollectionOfferTotal) {
    t2 = msg => {
      setCollectionOfferTotal(msg.collectionOfferAggregatesTotal);
    };
    $[2] = setCollectionOfferTotal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useSubscription(t1, t2);
}